module.exports = __webpack_public_path__ + "img/Practice_Text.b772cae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Practice_Text.png
// module id = 585
// module chunks = 5